import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import { Button } from "@ui/Button";
import { handleFileDownload } from "@/utils/download";

const DownloadExampleButton: FC<{ fileUrl: string }> = ({ fileUrl }) => {
  const { t } = useTranslation();
  const fileName = t("summary.file.exampleFileName");

  return (
    <Button
      variant="link"
      className="h-fit p-0"
      onClick={() => handleFileDownload(fileName, t, fileUrl)}
      type="button"
      data-test="download-example-button"
    >
      <Download className="size-6" strokeWidth={1.5} />
      <span className="text-base font-medium">{fileName}</span>
    </Button>
  );
};

export default DownloadExampleButton;
